{
  "label": "Gruppe von Benutzern",
  "button": {
    "delete": "Die Gruppe entfernen",
    "create": "Neue Gruppe"
  },
  "confirmDelete": {
    "title": "Gruppenentfernung",
    "description": "Die ausgewählte Gruppe „{userGroupName}“ wird entfernt."
  },
  "cannotDelete": {
    "title": "Die Gruppe kann nicht entfernt werden",
    "description": "Die ausgewählte Gruppe „{userGroupName}“ ist {usersCount} Benutzern zugeordnet."
  },
  "empty": "Keine Gruppen gefunden",
  "search": "Nach Namen suchen",
  "create": {
    "title": "Neue Gruppe",
    "confirm": {
      "title": "Gruppenerstellung"
    }
  },
  "update": {
    "title": "Gruppe ändern",
    "confirm": {
      "title": "Gruppe bearbeiten"
    }
  },
  "confirm": {
    "message": "Bestätigen Sie den Abbruch des Vorgangs? Alle nicht gespeicherten Daten gehen verloren."
  },
  "information": "Gruppeninformationen",
  "name": "Gruppenname",
  "sector": {
    "title": "Sektoren"
  },
  "sectors": {
    "label": "Mit der Gruppe verbundene Sektoren"
  },
  "addUsers": {
    "title": "Benutzer hinzufügen"
  }
}
